export default "__VITE_ASSET__DbJjaU6C__"